import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { generatePath } from 'react-router-dom';
import { CardContent, CardHeader, Typography } from '@mui/material';
import { get } from 'lodash';
import { DashboardTableCard } from '../../../../components/Dashboard/DashboardTableCard';
import { getMyRescues } from '../../../../helpers/RescuesHelper';
import MyClaimedRescues from './Component/MyClaimedRescues';
import useRescuerDashboardActions from '../../../../hooks/useRescuerDashboardActions';
import routes from '../../../../routes';
import useActiveUser from '../../../../hooks/useActiveUser';
import useHasActiveFeatureFlag from '../../../../hooks/useFeatureFlags';
import { FF_REQUIRE_FOOD_SAFETY_COURSE_COMPLETION } from '../../../../components/FeatureFlagWrapper';
import FoodSafetyCourseConfirmationDialog from '../../../../components/FoodSafetyCourseConfirmationDialog';

const MyRescuesDesktop = ({ history }) => {
  const dispatch = useDispatch();
  const activeUser = useActiveUser();
  const coursesEntities = useSelector((state) => state.entities.users.courses);
  const courses = coursesEntities.byUserId[activeUser.id] || [];
  const coursesCompleted =
    activeUser?.courses_status === 'Completed' ||
    (courses.length > 0 &&
      courses.every((course) =>
        course?.modules.length > 0 ? course.modules.every((module) => module.completed) : false
      ));
  const hideFoodSafetyDialog = useSelector(state => state.ui.persisted.hideFoodSafetyDialog);
  const rescuesEntities = useSelector(state => state.entities.rescues);
  const claimedRescues = getMyRescues(activeUser.id, rescuesEntities);
  const { fetchMyFrusTab } = useRescuerDashboardActions();
  const hasActiveRequireFoodSafetyFF = useHasActiveFeatureFlag(FF_REQUIRE_FOOD_SAFETY_COURSE_COMPLETION);
  const isInFlight =
    rescuesEntities.inflight || get(rescuesEntities, ['claimedAndAdoptedIds', activeUser.id, 'inflight'], true);
  const showFoodSafetyDialog = !coursesCompleted && (hasActiveRequireFoodSafetyFF || !hideFoodSafetyDialog);

  useEffect(() => {
    fetchMyFrusTab(false, false);
  }, [dispatch]);

  const onCellClick = (rescue) => history.push(generatePath(routes.rescue, { rescueId: rescue.id }));

  return (
    <>
      {showFoodSafetyDialog && <FoodSafetyCourseConfirmationDialog />}

      <DashboardTableCard isLoading={isInFlight}>
        <CardHeader
          subheader={
            claimedRescues.length > 0 ? (
              <Typography variant="body2" color="textSecondary">
                Showing all of your upcoming rescues.
              </Typography>
            ) : null
          }
        />
        <CardContent>
          <MyClaimedRescues
            isLoading={isInFlight}
            claimedRescues={claimedRescues}
            handleCellClick={onCellClick}
          />
        </CardContent>
      </DashboardTableCard>
    </>
  );
};

export default MyRescuesDesktop;

